<template>
    <div id="bottom">
      <div id="info">
        <div id="content">
          <el-row :gutter="16">
            <el-col :span="12">
              <div class="title">联系我们</div>
              <div class="color-block"></div>
              <div class="contact-info">
                <img src="~assets/homepage/qrcode.png" alt="二维码" class="qr">
                <div class="contact-text">
                  <p>服务热线：4006-0531-77</p>
                  <p>技术支持：0531-88873003</p>
                  <p>北京地址：北京市海淀区高粱桥斜街28号院6号楼二层201-205室</p>
                  <p>宁波地址：宁波市鄞州区科技孵化园A栋707</p>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="title">友情链接</div>
              <div class="color-block"></div>
              <div class="link">
                <p v-for="(item, index) in friendHref"
                   :key="index">
                  <a :href="item.path"
                     target="_blank">{{item.name}}</a>
                </p>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="title">联系反馈</div>
              <div class="color-block"></div>
              <div class="link">
                <p><a href="#"
                     target="_blank">问题反馈</a></p>
                <p><router-link :to="{name: 'aboutUs'}">关于我们</router-link></p>
              </div>
            </el-col>
          </el-row>
        </div>

      </div>
      <div id="law">
        ©2014-{{time}} 宁波优策信息技术有限公司 备案号：
        <a href="http://beian.miit.gov.cn/" target="_blank" rel="noopener">浙ICP备19030754</a>
      </div>
    </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class Footer extends Vue {
  friendHref = [
    { name: '产业政策大数据平台', path: 'http://www.spolicy.com/' },
    { name: '链接二', path: '#' },
    { name: '链接三', path: '#' },
    { name: '链接四', path: '#' },
    { name: '链接五', path: '#' },
  ];

  time = new Date().getFullYear();
}
</script>

<style lang="scss" scoped>
#bottom {
  #info {
    width: 100%;
    padding-top: 60px;
    height: 312px;
    background: url("~assets/homepage/footer_back.png");
    background-size: cover;
    #content {
      width: 1572px;
      margin: auto;
      .title {
        font-size: 20px;
        color: #5C6B7E;
        line-height: 28px;
        font-weight: 600;
        margin-bottom: 10px;
      }
      .color-block {
        width: 60px;
        height: 4px;
        background-color: #5C6B7E;
        margin-bottom: 21px;
      }
      .link {
        p {
          margin: 0;
        }
        p + p {
          margin-top: 20px;
        }
        a {
          color: #7B8A9D;
          text-decoration: none;
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
        }
      }
      .contact-info {
        .qr {
          width: 140px;
          height: 140px;
          margin-right: 31px;
        }
        .contact-text {
          color: #7B8A9D;
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          display: inline-block;
          vertical-align: top;
          p {
            margin: 0;
          }
          p + p {
            margin-top: 20px;
          }
        }
      }
    }
  }
  #law {
    background: #91969F;
    color: #ffffff;
    height: 22px;
    line-height: 22px;
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    a {
      text-decoration: none;
      color: currentColor;
    }
  }
}
</style>
